import { jsx as _jsx } from "react/jsx-runtime";
import { Link, NavLink } from 'react-router-dom';
import { createTo } from './utils/createTo';
/**
 * A component that wraps the native react-router-dom <Link> component with a
 * strongly typed interface.
 */
export const AppLink = (options) => {
    return (_jsx(Link, Object.assign({}, options, { to: createTo(options) }, { children: options.children })));
};
/**
 * A component that wraps the native react-router-dom <NavLink> component with a
 * strongly typed interface.
 */
export const AppNavLink = (options) => {
    return (_jsx(NavLink, Object.assign({}, options, { to: createTo(options) }, { children: options.children })));
};
